import React, { useContext } from 'react';

import {
  Onboarding,
  OnboardingContext,
  OnboardingSubtitle,
  OnboardingTitle,
} from 'registration/containers/Onboarding';

import { Center } from 'shared/components/ihcl/positioning';
import { ButtonSelect } from 'shared/components/ihcl/v2/button-select';
import {
  employmentTypeValueOptions,
  shiftPreferenceOptions,
} from 'shared/constants/selectOptions';

const OnboardingShiftEmployment = ({
  stepNumber,
}: OnboardingTechRolesProps) => {
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  /* eslint-disable @typescript-eslint/naming-convention */
  const { employment_type = [], shift_preferences = [] } = onboardingData;

  const stepKeys = ['employment_type', 'shift_preferences'];

  return (
    <Center>
      <Onboarding
        autoSpacedStepContents={false}
        centerStepContents
        isNextDisabled={
          shift_preferences.length === 0 || employment_type.length === 0
        }
        currentStep={stepNumber}
        stepKeys={stepKeys}
        stepName="Shift preferences"
      >
        <OnboardingTitle>Let&apos;s get some details</OnboardingTitle>
        <OnboardingSubtitle>Please select all that apply</OnboardingSubtitle>
        <OnboardingSubtitle $fontWeight="bold">
          What are your shift preferences?
        </OnboardingSubtitle>
        <ButtonSelect
          className="justify-center"
          options={shiftPreferenceOptions}
          values={shift_preferences.map((option) => option.value)}
          onValuesChange={(next) =>
            setOnboardingData({
              ...onboardingData,
              shift_preferences: shiftPreferenceOptions.filter((option) =>
                next.includes(option.value)
              ),
            })
          }
        />
        <OnboardingSubtitle $fontWeight="bold">
          What are your employment type preferences?
        </OnboardingSubtitle>
        <ButtonSelect
          className="flex-col items-center"
          options={employmentTypeValueOptions}
          values={employment_type.map((option) => option.value)}
          onValuesChange={(next) =>
            setOnboardingData({
              ...onboardingData,
              employment_type: employmentTypeValueOptions.filter((option) =>
                next.includes(option.value)
              ),
            })
          }
        />
      </Onboarding>
    </Center>
  );
};
type OnboardingTechRolesProps = {
  stepNumber: number;
};

export default OnboardingShiftEmployment;
